import { AbilityBuilder, createMongoAbility, createAliasResolver } from '@casl/ability';

const resolveAction = createAliasResolver({
  cru: ['create', 'read', 'update'],
  crud: ['cru', 'delete'],
});

// I guess... here we can use "defineAbility" also
export function defineAbilityFor(user) {
  const { can, cannot, build } = new AbilityBuilder(createMongoAbility);

  if (user) {
    const userRoles = user.roles.map(role => role.name)

    if (userRoles.includes('admin')) {
      can('manage', 'all');
    } else if (userRoles.includes('dc')) {
      can(['create', 'read', 'update', 'destroy'], 'Timesheet');
      can(['crud', 'print', 'save_email_sent', 'clear_email_sent'], 'FollowUp');
      can('crud', 'Transferee');
      can('crud', 'Tour');
      can('crud', 'Comment');
      can('crud', 'Event');
      can('crud', 'Todo');
      can('crud', 'Document');
      can('crud', 'Schedule');
      can('read', 'Search');
      can('read', 'Report');
      can('read', 'AdminLinks');
    } else if (userRoles.includes('dg')) {
      can('create', 'Timesheet');
      can(['read', 'update'], 'Timesheet', { destinationGuideId: user.dgId });
      can('create', 'FollowUp');
      can(['cru', 'print'], 'FollowUp', { destinationGuideId: user.dgId });
      can('read', 'Tour');
      can('crud', 'Event', { eventableType: 'User', assignedToUserId: user.id });
      can('crud', 'Event', { eventableType: 'Tour'});
      can('read', 'Document');
    } else if (userRoles.includes('relo_company')) {   
      can('read', 'all'); 
    }
  }

  return build({
    detectSubjectType: object => object.className,
    resolveAction,
  });
}

// Create an initial empty ability instance
export const ability = defineAbilityFor(null);